import React, { useEffect } from 'react';
import formatPrice from '@ibibo/format-price';
import getDateObject from '@stencil/flights-date-utils/src/get-date-object';
import * as S from './listing-section.styles';

const DestinationCardUI = props => {
  const destinationCardRef = React.createRef();

  const {
    active,
    handleSelectedDestination,
    handleOpenDtlSection,
    handleBannerImage,
    index,
    destination,
    cityRef,
    countryRef,
    continentRef,
    source,
    isRoundTrip = true
  } = props;
  const { toCity, minCostStop, toCountry } = destination;
  const sourceIata = source?.iata || '';

  useEffect(() => {
    if (active && destinationCardRef.current.scrollIntoView) {
      destinationCardRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [active]);

  const airportsVia = airports => {
    let result = ' ';
    if (airports === undefined) {
      return result;
    }
    airports &&
      airports.map(airport => {
        result += airport.airportCode + ' - ';
      });
    return result;
  };

  const getDurationForDisplay = dur => {
    let duration = +dur / 60;
    let hours = Math.floor(duration);
    let minutes = ((duration - hours) * 60).toFixed(0);

    return `${hours ? `${hours}h` : ''} ${minutes}m`;
  };

  return (
    <S.ListWrap
      className={active}
      onClick={() => {
        handleSelectedDestination(destination);
        handleOpenDtlSection(index);
        handleBannerImage(destination.bannerImageUrl);
      }}
      ref={destinationCardRef}
    >
      <S.LeftSection>
        <img
          className="avatar"
          src={destination.imageUrl}
          width="70"
          height="70"
          onError={e => {
            e.target.onerror = null;
            e.target.src =
              'https://imgak.goibibo.com/flights-gi-assets/images/dt/destination-picker/random-thumbnail-2.png';
          }}
        />
      </S.LeftSection>
      <S.RightSection>
        <div className="dF justifyBetween">
          <p className="heading marginB4">{cityRef && cityRef[toCity]}</p>
          <p className="pricing">
            {formatPrice(minCostStop?.price)} <span className="arrow"></span>
          </p>
        </div>
        <div className="dF justifyBetween">
          <p className={'marginB15 ' + (isRoundTrip ? 'rtSubHeading' : 'subheading')}>
            {countryRef && countryRef[toCountry]}
          </p>
          <p className="dateTag marginB15">
            {minCostStop && minCostStop?.depDate && getDateObject(minCostStop?.depDate).dddddmmm}
          </p>
        </div>
        <div className="dF justifyBetween">
          <div>
            <p className="fromto">
              {sourceIata}- {airportsVia(minCostStop?.onwardVia)}
              {toCity}
            </p>
            <p className="stops">
              {minCostStop?.onwardVia && minCostStop?.onwardVia.length == 1
                ? '1 stop '
                : minCostStop?.onwardVia && minCostStop?.onwardVia.length > 1
                ? '1+ stop '
                : 'Non stop '}{' '}
              - <span>{getDurationForDisplay(minCostStop?.onwardFlightDurationInMins)}</span>
            </p>
          </div>
          {isRoundTrip ? (
            <div>
              <p className="fromto">
                {toCity} - {airportsVia(minCostStop?.returnVia)}
                {sourceIata}
              </p>
              <p className="stops">
                {minCostStop?.returnVia && minCostStop?.returnVia.length == 1
                  ? '1 stop '
                  : minCostStop?.returnVia && minCostStop?.returnVia.length > 1
                  ? '1+ stop '
                  : 'Non stop '}{' '}
                -{' '}
                <span>
                  {minCostStop?.returnFlightDurationInMins &&
                    getDurationForDisplay(minCostStop?.returnFlightDurationInMins)}
                </span>
              </p>
            </div>
          ) : (
            <p>
              {minCostStop?.onwardFlightDurationInMins ? (
                <span className="timeTag">
                  {' '}
                  {minCostStop?.onwardFlightDurationInMins &&
                    getDurationForDisplay(minCostStop?.onwardFlightDurationInMins)}
                </span>
              ) : null}
            </p>
          )}
        </div>
      </S.RightSection>
    </S.ListWrap>
  );
};
export default DestinationCardUI;
